import React, { useEffect, useState } from "react";
import Filter from "../../../../assets/Icons/filter.png";
import ExcelExport from "../../../../compnenets/commons/xls";
import Modal from "react-responsive-modal";
import Close from "../../../../assets/Images/close.png";
import leftArrow from "../../../../assets/Images/left-arrow.png";
import rightArrow from "../../../../assets/Images/right-arrow.png";
import "../archival.css";
import { PROJECT_ARCHIVAL } from "../../../../services/apiCalls/archivalApiCalls";
import { DPR_API } from "../../../../services/apiCalls/dprApiCalls";

export default function Machinary({ project }) {
  const [open, setOpen] = useState(false);
  const [machinaryData, setMachinaryData] = useState([]);
  const onCloseModal = () => setOpen(true);
  const [machineryList, setMachineryList] = useState([]);
  const [filterData, setFilterData] = useState({
    ProjectID: project.project_id,
    startDate: "",
    endDate: "",
    Machinery: "",
    sortOrder: "ASC",
    sortBy: "machinery_name",
  });

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const totalPages = Math.ceil(machinaryData.length / rowsPerPage);

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = machinaryData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  const fetchArchivalMachinary = async (payload) => {
    let obj = payload;
    if (!payload) {
      obj = {
        ProjectID: project.project_id,
      };
    }
    const response = await PROJECT_ARCHIVAL.GetResourcesMachineryDetails(obj);
    if (response && response.MachineryList.length > 0) {
      setMachinaryData(response.MachineryList);
    } else {
      setMachinaryData([]);
    }
  };
  const getMachinery = async () => {
    const machinery = await DPR_API.get_Resource_Machinery();
    if (machinery && machinery?.Machinery?.length) {
      setMachineryList(machinery?.Machinery);
    } else {
      setMachineryList([]);
    }
  };
  useEffect(() => {
    fetchArchivalMachinary();
  }, []);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterData((prev) => ({ ...prev, [name]: value }));
  };
  return (
    <React.Fragment>
      <Modal open={open} onClose={onCloseModal} center>
        <div className="d-flex justify-content-between">
          <div>
            <span className="resorces">Resource Machinery Filter</span>
          </div>
          <div>
            <img
              src={Close}
              width={20}
              onClick={() => {
                setOpen(false);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="card mt-0 card-bd-none">
            <div className="card-body">
              <div className="row">
                <div className="col-6">
                  <label className="filter-label">Start date</label>
                  <input
                    type="date"
                    className="form-control shadow-none"
                    name="startDate"
                    value={filterData.startDate}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-6">
                  <label className="filter-label">End date</label>
                  <input
                    type="date"
                    name="endDate"
                    value={filterData.endDate}
                    onChange={handleChange}
                    className="form-control shadow-none"
                  />
                </div>
              </div>
              <div className="row mt-1">
                <div className="col-6">
                  <label className="filter-label">Machinery name</label>
                  <select
                    name="Machinery"
                    value={filterData.Machinery}
                    onChange={handleChange}
                    className="filter-label"
                    style={{
                      width: "100%",
                      height: 31,
                      border: "1px solid #e6e3e3",
                      borderRadius: 4,
                    }}
                  >
                    <option>Select machinery</option>
                    {machineryList?.length
                      ? machineryList.map((val) => (
                          <option value={val.machinery_id}>
                            {val?.machinary_name}
                          </option>
                        ))
                      : ""}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="d-flex justify-content-between">
            <div style={{ marginLeft: 20 }}>
              <span className="resorces">Sort Machinery</span>
            </div>
            <div style={{ marginRight: 20 }}>
              <select
                name="sortOrder"
                value={filterData.sortOrder}
                onChange={handleChange}
                className="filter-label"
                style={{
                  width: "100%",
                  height: 31,
                  border: "1px solid #e6e3e3",
                  borderRadius: 4,
                }}
              >
                <option>ASC</option>
                <option>DES</option>
              </select>
            </div>
          </div>
        </div>

        <div className="row" style={{ marginLeft: 20 }}>
          {["machinery_name", "created_date"].map((sortOption) => (
            <div className="form-check" key={sortOption}>
              <input
                className="form-check-input shadow-none"
                type="radio"
                name="sortBy"
                id={sortOption}
                value={sortOption}
              />
              <label htmlFor={sortOption} style={{ fontSize: 14 }}>
                {sortOption === "machinery_name"
                  ? "Machinery name"
                  : "Created date"}
              </label>
            </div>
          ))}
        </div>

        <div className="d-flex justify-content-center mt-5 pb-4">
          <button
            className="btn btn-primary"
            onClick={() => {
              fetchArchivalMachinary(filterData);
              setOpen(false);
            }}
          >
            Filter
          </button>
        </div>
      </Modal>
      <div className="row">
        <div className="d-flex justify-content-end">
          <div className="download-icon">
            <ExcelExport
              data={machinaryData}
              fileName="Machinery"
              sheet="Machinery List"
            />
          </div>
          <div className="filter-icon mx-2 my-auto">
            <img
              className=""
              onClick={() => {
                setOpen(true);
                getMachinery();
              }}
              src={Filter}
              width={20}
            />
          </div>
          <div className="my-auto" onClick={() => fetchArchivalMachinary()}>
            <span
              style={{
                cursor: "pointer",
                fontSize: 12,
                fontWeight: 500,
                background: "#8add79f7",
                padding: 5,
                borderRadius: 12,
              }}
            >
              Clear filters
            </span>
          </div>
        </div>
      </div>
      <div className="table-container-archival">
        <table id="custom-table-archival">
          <thead className="table-header-archival">
            <tr>
              <th>Sr No</th>
              {/* <th>Project Name</th>
              <th>Project ID</th>
              <th>Region</th>
              <th>Location</th>
              <th>Client</th>
              <th>Product Category</th>
              <th>Project Status</th> */}
              <th>Machinery name</th>
              <th style={{ whiteSpace: "nowrap" }}>Number of Machinery</th>
              <th>Created Date</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((row, index) => (
              <tr key={index}>
                <td>
                  <td>{index + 1 + (currentPage - 1) * 10}</td>
                </td>
                {/* <td>{project.Project_Name}</td>
                <td>{project.project_id}</td>
                <td>{project.Region}</td>
                <td>{project.Location}</td>
                <td>-</td>
                <td>{project.Product_Category}</td>
                <td>{project.ProjectStatus}</td> */}
                <td style={{ whiteSpace: "nowrap" }}>{row.Machinery}</td>
                <td
                  style={{
                    color: "rgb(102 104 106)",
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                >
                  <span className="no-of-resource">
                    {row.NumberOfMachinery}
                  </span>
                </td>
                <td>{new Date(row?.CreatedOn).toLocaleDateString('en-GB')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div
        className="pagination"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px 15px",
        }}
      >
        <div style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
          Showing{" "}
          {Math.min((currentPage - 1) * rowsPerPage + 1, machinaryData.length)}{" "}
          to {Math.min(currentPage * rowsPerPage, machinaryData.length)} of{" "}
          {machinaryData.length} entries
        </div>

        <div
          className="pagination-buttons"
          style={{
            fontSize: "14px",
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            gap: "5px",
          }}
        >
          {/* Left Arrow */}
          <button
            onClick={() => handleClick(Math.max(1, currentPage - 1))}
            disabled={currentPage === 1}
            style={{
              background: "none",
              border: "none",
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
            }}
          >
            <img
              src={leftArrow} // Replace with your actual image path
              alt="Previous"
              height="11px"
              width="7px"
              style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
            />
          </button>

          {/* Page Numbers */}
          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i}
              onClick={() => handleClick(i + 1)}
              style={{
                background: currentPage === i + 1 ? "#00B69B" : "transparent",
                color: currentPage === i + 1 ? "#fff" : "#000",
                border: "none",
                borderRadius: "50%",
                width: "30px",
                height: "30px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              {i + 1}
            </button>
          ))}

          {/* Right Arrow */}
          <button
            onClick={() => handleClick(Math.min(totalPages, currentPage + 1))}
            disabled={currentPage === totalPages}
            style={{
              background: "none",
              border: "none",
              cursor: currentPage === totalPages ? "not-allowed" : "pointer",
            }}
          >
            <img
              src={rightArrow} // Replace with your actual image path
              alt="Next"
              height="11px"
              width="7px"
              style={{ opacity: currentPage === totalPages ? 0.5 : 1 }}
            />
          </button>
        </div>
      </div>
    </React.Fragment>
  );
}
